import {useEffect} from 'react';

function useChangeTitle(
   title,
   {app = process.env.REACT_APP_APP_NAME || '', defaultTitle = 'DS-APP'} = {}
) {
   useEffect(() => {
      const newTitle = app && title ? `${title} - ${app}` : title;
      document.title = newTitle || defaultTitle;
   }, [title, app]);
}

export default useChangeTitle;
